import { useNavigate } from "react-router-dom";
import { ArrowLeft, Mail, Phone, MapPin, Clock, MessageSquare, Instagram, Facebook } from "lucide-react";

const C = {
  primary:"#f97316", dark:"#ea580c", light:"#fff7ed",
  white:"#ffffff", bg:"#f2f2f7", text:"#1c1c1e", sub:"#6b7280",
  border:"#e5e7eb",
};

export default function ContactUs() {
  const navigate = useNavigate();
  return (
    <div style={{ fontFamily:"'Plus Jakarta Sans',system-ui,sans-serif", background:C.bg, minHeight:"100vh", color:C.text }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,800;9..144,900&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}`}</style>

      {/* Header */}
      <div style={{ background:C.white, borderBottom:`1px solid ${C.border}`, padding:"14px 20px", display:"flex", alignItems:"center", gap:12, position:"sticky", top:0, zIndex:10 }}>
        <button onClick={() => navigate(-1)} style={{ background:"none", border:"none", cursor:"pointer", display:"flex" }}>
          <ArrowLeft size={22} color={C.text}/>
        </button>
        <div style={{ fontFamily:"'Fraunces',serif", fontWeight:900, fontSize:"1.15rem" }}>Contact Us</div>
      </div>

      <div style={{ maxWidth:640, margin:"0 auto", padding:"24px 20px 48px" }}>

        {/* Hero */}
        <div style={{ background:`linear-gradient(135deg,${C.dark},${C.primary})`, borderRadius:20, padding:"28px 24px", textAlign:"center", marginBottom:24 }}>
          <MessageSquare size={36} color="#fff" style={{ marginBottom:10 }}/>
          <div style={{ fontFamily:"'Fraunces',serif", fontWeight:900, fontSize:"1.5rem", color:"#fff", marginBottom:8 }}>We're here to help!</div>
          <div style={{ color:"rgba(255,255,255,0.85)", fontSize:"0.88rem", lineHeight:1.6 }}>
            Have a question or need support? Reach out to us — we'll respond within 24 hours.
          </div>
        </div>

        {/* Contact Details */}
        <div style={{ background:C.white, borderRadius:16, padding:"20px", marginBottom:16, border:`1px solid ${C.border}` }}>
          <div style={{ fontFamily:"'Fraunces',serif", fontWeight:800, fontSize:"1.1rem", marginBottom:16 }}>Contact Information</div>

          {[
            { Icon:Mail,   label:"Email",   value:"hello.quickry@gmail.com",  href:"mailto:hello.quickry@gmail.com",  color:"#2563eb" },
            { Icon:Phone,  label:"Phone",   value:"+91 98765 43210",           href:"tel:+919876543210",               color:"#16a34a" },
            { Icon:MapPin, label:"Address", value:"Akola, Maharashtra — 444001, India", href:null,                    color:"#f97316" },
          ].map(({ Icon, label, value, href, color }) => (
            <div key={label} style={{ display:"flex", gap:14, alignItems:"flex-start", marginBottom:16, paddingBottom:16, borderBottom:`1px solid ${C.border}` }}>
              <div style={{ width:44, height:44, borderRadius:12, background:`${color}15`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                <Icon size={20} color={color}/>
              </div>
              <div>
                <div style={{ fontSize:"0.72rem", fontWeight:700, color:C.sub, textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:4 }}>{label}</div>
                {href ? (
                  <a href={href} style={{ fontSize:"0.9rem", fontWeight:700, color:C.text, textDecoration:"none" }}>{value}</a>
                ) : (
                  <div style={{ fontSize:"0.9rem", fontWeight:700 }}>{value}</div>
                )}
              </div>
            </div>
          ))}

          {/* Hours */}
          <div style={{ display:"flex", gap:14, alignItems:"flex-start" }}>
            <div style={{ width:44, height:44, borderRadius:12, background:"#f5f3ff", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <Clock size={20} color="#7c3aed"/>
            </div>
            <div>
              <div style={{ fontSize:"0.72rem", fontWeight:700, color:C.sub, textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:4 }}>Support Hours</div>
              <div style={{ fontSize:"0.9rem", fontWeight:700 }}>Monday – Sunday</div>
              <div style={{ fontSize:"0.82rem", color:C.sub, marginTop:2 }}>9:00 AM – 10:00 PM IST</div>
            </div>
          </div>
        </div>

        {/* Business Address */}
        <div style={{ background:C.white, borderRadius:16, padding:"20px", marginBottom:16, border:`1px solid ${C.border}` }}>
          <div style={{ fontFamily:"'Fraunces',serif", fontWeight:800, fontSize:"1.1rem", marginBottom:12 }}>Business Address</div>
          <p style={{ fontSize:"0.88rem", color:C.sub, lineHeight:1.8 }}>
            <strong style={{ color:C.text }}>Quickry</strong><br/>
            Akola, Maharashtra — 444001<br/>
            India
          </p>
        </div>

        {/* Grievance */}
        <div style={{ background:"#fef2f2", borderRadius:16, padding:"20px", border:"1px solid #fecaca" }}>
          <div style={{ fontFamily:"'Fraunces',serif", fontWeight:800, fontSize:"1rem", marginBottom:8, color:"#dc2626" }}>Grievance Officer</div>
          <p style={{ fontSize:"0.85rem", color:C.sub, lineHeight:1.7 }}>
            In accordance with the Information Technology Act 2000 and rules made thereunder, the name and contact details of the Grievance Officer are provided below:
          </p>
          <div style={{ marginTop:12, fontSize:"0.85rem", lineHeight:1.8 }}>
            <strong>Name:</strong> Quickry Support Team<br/>
            <strong>Email:</strong> hello.quickry@gmail.com<br/>
            <strong>Address:</strong> Near Khandelwall School Old city Dabki Road Akola, Maharashtra — 444001<br/>
            <strong>Response Time:</strong> Within 30 days of receipt of complaint
          </div>
        </div>

      </div>
    </div>
  );
}
